module.exports = __webpack_public_path__ + "img/load-teacherApp.cba629a0.png";